// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"b9f2525e","504":"8c960cf0","825":"aeb0c35c"}[chunkId] + ".chunk.js";
};